export default __webpack_public_path__ + "static/media/Icon-PTO.9ec2208c.svg";